var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// removed import of scss-style
import * as React from 'react';
import { observable, reaction } from 'mobx';
import { observer } from 'mobx-react';
import classnames from 'classnames';
class ScrollView extends React.Component {
    componentDidMount() {
        this.disableScrolling();
        const onResize = () => {
            if (window.matchMedia('(max-width: 767px)').matches) {
                if (this.scrollingActive) {
                    this.scrollingActive = false;
                }
            }
            else if (!this.scrollingActive) {
                this.scrollingActive = true;
            }
            this.toggleScrollBar();
        };
        this.resizeListener = onResize.bind(this);
        window.addEventListener('resize', this.resizeListener);
        reaction(() => this.scrollingActive, () => {
            this.toggleScrollingActive();
        });
        onResize();
    }
    toggleScrollingActive() {
        if (this.scrollingActive) {
            this.activateScrolling();
        }
        else {
            this.disableScrolling();
        }
    }
    activateScrolling() {
        const { scrollContainer } = this;
        const onScroll = (e) => {
            if (scrollContainer === e.target || scrollContainer.contains(e.target)) {
                const { scrollTop, scrollHeight, clientHeight } = scrollContainer;
                if (scrollTop + clientHeight === scrollHeight && e.deltaY > 0) {
                    e.preventDefault();
                }
                else if (scrollTop === 0 && e.deltaY < 0) {
                    e.preventDefault();
                }
            }
            else {
                e.preventDefault();
            }
        };
        let lastY = 0;
        const onTouchStart = (e) => {
            if (e.cancelable) {
                e.preventDefault();
            }
            lastY = e.changedTouches[0].clientY;
        };
        const onTouchMove = (e) => {
            if (scrollContainer === e.target || scrollContainer.contains(e.target)) {
                const deltaY = lastY - e.changedTouches[0].clientY;
                const { scrollTop, scrollHeight, clientHeight } = scrollContainer;
                if (scrollTop + clientHeight === scrollHeight && deltaY > 0) {
                    if (e.cancelable) {
                        e.preventDefault();
                    }
                }
                else if (scrollTop === 0 && deltaY < 0) {
                    if (e.cancelable) {
                        e.preventDefault();
                    }
                }
            }
            else {
                if (e.cancelable) {
                    e.preventDefault();
                }
            }
        };
        this.scrollListener = onScroll.bind(this);
        window.addEventListener('wheel', this.scrollListener);
        this.touchStartListener = onTouchStart.bind(this);
        window.addEventListener('touchstart', this.touchStartListener);
        this.touchMoveListener = onTouchMove.bind(this);
        window.addEventListener('touchmove', this.touchMoveListener, {
            passive: false
        });
    }
    disableScrolling() {
        window.removeEventListener('wheel', this.scrollListener);
        window.removeEventListener('touchstart', this.touchStartListener);
        window.removeEventListener('touchmove', this.touchMoveListener);
        if (this.scrollContainer.scrollTo) {
            this.scrollContainer.scrollTo(0, 0);
        } // Fails in IE/Edge
    }
    componentDidUpdate() {
        this.toggleScrollBar();
    }
    toggleScrollBar() {
        const { scrollContainer, scrollIndicator, scrollBar } = this;
        if (!scrollContainer || !scrollIndicator || !scrollBar) {
            return;
        }
        scrollContainer.scrollTop = 0;
        scrollIndicator.style.top = '0';
        if (scrollContainer.scrollHeight <= scrollContainer.clientHeight) {
            scrollBar.style.display = 'none';
        }
        else {
            scrollBar.style.display = 'block';
        }
        const indicatorHeight = (scrollContainer.clientHeight / scrollContainer.scrollHeight) *
            scrollBar.clientHeight;
        scrollIndicator.style.height = indicatorHeight + 'px';
    }
    componentWillUnmount() {
        this.disableScrolling();
        window.removeEventListener('resize', this.resizeListener);
    }
    onScroll(target) {
        const { scrollBar, scrollIndicator } = this;
        if (!scrollBar || !scrollIndicator) {
            return;
        }
        const barDist = scrollBar.clientHeight - scrollIndicator.clientHeight;
        const articleDist = target.scrollHeight - target.clientHeight;
        const top = target.scrollTop * (barDist / articleDist);
        scrollIndicator.style.top = `${top}px`;
    }
    render() {
        const { children } = this.props;
        return (React.createElement("div", { className: classnames('ScrollView', {
                'ScrollView--inactive': !this.scrollingActive
            }), ref: ref => (this.dom = ref) },
            React.createElement("div", { className: "ScrollView__Container", ref: ref => (this.scrollContainer = ref), onScroll: e => this.onScroll(e.target) }, children),
            React.createElement("div", { className: "ScrollView__Scrollbar", ref: ref => (this.scrollBar = ref) },
                React.createElement("div", { className: "ScrollView__Indicator", ref: ref => (this.scrollIndicator = ref) }))));
    }
}
__decorate([
    observable
], ScrollView.prototype, "scrollingActive", void 0);
export default observer(ScrollView);
